import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody, Alert, Accordion, AccordionSummary, AccordionDetails} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import reportChangeLog from '../../../types/reports/reportChangeLog';
import changeLogReportItem from '../../../types/reports/changeLogReportItem';
import reportChangeLogItemDiff from '../../../types/reports/reportChangeLogItemDiff';


interface Props {
   changes?:reportChangeLog[];
}

export enum ChangeType {
    Unclear = 0,
    Add = 1,
    Update = 2,
    Delete = 3
};


const ChangeLogHistory = (props: Props): JSX.Element => {

    const theme = useTheme();

    let logs = props.changes;

    const setChangeType = (changeTypeId: number) => {

        let statusColor = '';
        let statusBgColor = '';
        let statusText = '';

        switch (changeTypeId) {
            case ChangeType.Add:
                statusBgColor = alpha(theme.palette.success.light, 0.1);
                statusColor = theme.palette.success.dark;
                statusText = 'Added';
                break;
            case ChangeType.Update:
                statusBgColor = alpha(theme.palette.primary.light, 0.1);
                statusColor = theme.palette.primary.dark;
                statusText = 'Updated';
                break;
            case ChangeType.Delete:
                statusBgColor = alpha(theme.palette.error.light, 0.1);
                statusColor = theme.palette.error.dark;
                statusText = 'Deleted';
                break;
        }

        return (
            <Typography
                variant={'caption'}
                fontWeight={550}
                sx={{
                  bgcolor: `${statusBgColor}`,
                  color: `${statusColor}`,
                  paddingX: 1.5,
                  paddingY: 0.5,
                  borderRadius: 4,
                  display: 'inline',
                }}
              >
              {statusText}
              </Typography>
        );

    }

    const displayAmendedReportChanges = (log: reportChangeLog) => {
        if(log && log.reportItems && log.reportItems.length > 0){
            return (
                    <TableContainer>
                        <Table aria-label="amended items table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Category
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Item
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Type
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Changes
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {log.reportItems?.map((reportItem: changeLogReportItem, index) => (
                                    reportItem.diffs.map((diff:reportChangeLogItemDiff, index) => (
                                                diff.transactionType !== ChangeType.Unclear &&
                                                <TableRow key={index}>
                                                     {
                                                        index > 0 ? null : 
                                                        <TableCell rowSpan={reportItem.diffs.length}>
                                                            <Typography variant={'subtitle2'}>
                                                               {getReportItemCategory(reportItem.recordTypeId)}
                                                            </Typography>
                                                        </TableCell>
                                                    }
                                                    {
                                                        index > 0 ? null : 
                                                        <TableCell rowSpan={reportItem.diffs.length}>
                                                            <Typography variant={'subtitle2'}>
                                                               {reportItem.itemIdentifier}
                                                            </Typography>
                                                        </TableCell>
                                                    }
                                                    <TableCell>
                                                        {setChangeType(diff.transactionType)}
                                                    </TableCell>
                                                    <TableCell>
                                                    {
                                                        diff.transactionType === ChangeType.Update &&
                                                        <Typography variant={'subtitle2'}>
                                                          <b>{diff.fieldName}</b>: {formatChangeValues(diff)}
                                                         </Typography>
                                                    }
                                                    </TableCell>
                                                </TableRow>
                                    ))
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
            );
        }
        return null;
    }   


    const displayEditItemChanges = (log: reportChangeLog) => {
        if(log && log.reportItems && log.reportItems.length > 0){
            return (
                    <TableContainer>
                        <Table aria-label="amended items table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Item
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Purpose
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Type
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'} fontWeight={600}>
                                            Changes
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {log.reportItems?.map((reportItem: changeLogReportItem, index) => (
                                    reportItem.diffs.map((diff:reportChangeLogItemDiff, index) => (
                                        diff.transactionType !== ChangeType.Unclear &&
                                            <TableRow key={index}>
                                                    {
                                                        index > 0 ? null : 
                                                        <TableCell rowSpan={reportItem.diffs.length}>
                                                            <Typography variant={'subtitle2'}>
                                                                {reportItem.itemIdentifier}
                                                            </Typography>
                                                        </TableCell>
                                                    }
                                                    {
                                                        index > 0 ? null : 
                                                        <TableCell rowSpan={reportItem.diffs.length}>
                                                            <Typography variant={'subtitle2'}>
                                                                {reportItem.description}
                                                            </Typography>
                                                        </TableCell>
                                                    }
                                                    <TableCell>
                                                        {setChangeType(diff.transactionType)}
                                                    </TableCell>
                                                    <TableCell>
                                                    {
                                                        diff.transactionType === ChangeType.Update &&
                                                        <Typography variant={'subtitle2'}>
                                                          <b>{diff.fieldName}</b>: {diff.previousValue}   {'→'}  <span style={{ color: 'blue' }}>{diff.newValue}</span>
                                                         </Typography>
                                                    }
                                                    </TableCell>
                                            </TableRow>
                                    ))
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
            );
        }
        return null;
    }   


    const formatChangeValues = (diff: reportChangeLogItemDiff) => {

        if(diff.fieldName === 'Amount'){
            let prevAmount = Number(diff.previousValue).toFixed(2);
            let newAmount = Number(diff.newValue).toFixed(2);
            return (
                <>
                    ${prevAmount} {'→'} <span style={{ color: 'blue' }}>${newAmount}</span>
                </>
            );
        }
        return (
            <>
                {diff.previousValue}   {'→'}  <span style={{ color: 'blue' }}>{diff.newValue}</span>
            </>
        );
    }

    const getReportItemCategory = (recordTypeId: number) => {
        switch (true) {
            case recordTypeId > 200 && recordTypeId <= 299:
                return 'Receipt';
            case recordTypeId > 300 && recordTypeId <= 399:
                return 'Expenditure';
            case recordTypeId > 400 && recordTypeId <= 499:
                return 'In-kind';
            case recordTypeId > 500 && recordTypeId <= 599:
                return 'Liability';
            case recordTypeId === 951:
                return 'Subvendor Sub-Item';
            default:
                return '';
        }   
    }

    
    return (
        <Grid container spacing={1} marginBottom={2}>
        {
            logs && logs.length > 0 && logs.map((log, index) => (
                <Accordion key={index} sx={{ width: '100%'}} defaultExpanded={true}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Alert icon={false} severity="warning" sx={{ width: '100%'}}>
                            <Typography variant="body2">
                                <b>{log.header}: {log.reportItems.length} item(s) changes </b> 
                                {log.isAmendment && log.amendmentReason && <>(reason: {log.amendmentReason})</>}
                            </Typography>
                        </Alert>
                    </AccordionSummary>
                    <AccordionDetails>
                        {
                            log.isAmendment &&
                            displayAmendedReportChanges(log)
                        }
                        {
                            !log.isAmendment &&
                            displayEditItemChanges(log)
                        }
                    </AccordionDetails>
                </Accordion>
                ))
        }
        </Grid>
    );
}

export default ChangeLogHistory;